























import {Component} from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';

@Component({components: {}})
export default class Agenda extends Slide {
  get items() {
    const res = [];
    for (const i of this.data.Children) {
      const child = this.data.Items.find((x: any) => x.Id === i);
      if (child.Kind === 'group' && child.Hidden !== true) {
        const v = this.getTitle(child.Type);
        if (v !== '') {
          res.push({Value: v});
        }
      }
    }
    return res;
  }

  getTitle(type: string) {
    switch (type) {
      case 'cashflow': return 'Kassaflödesanalys';
      case 'overview': return 'Översikt';
      case 'profitloss': return 'Resultaträkning';
      case 'balance': return 'Balansräkning';
      case 'compass': return 'Bolagskompass';
      case 'yearend': return 'Bokslut';
      case 'competition': return 'Konkurrentjämförelse';
      case 'gtAdvisory': return 'Vår rådgivning';
      case 'completion': return 'Avslutning';
      case 'sustainability': return 'Hållbarhet';

      case 'preClosingMeeting_thisYear': return 'Året hittills';
      case 'preClosingMeeting_remaining': return 'Helårsprognos';
      case 'preClosingMeeting_future': return 'Ägarplanering';
      case 'preClosingMeeting_schedule': return 'Tidplan';
      case 'preClosingMeeting_misc': return 'Övrigt';
      case 'preClosingMeeting_feedback': return 'Feedback';
      case 'preClosingMeeting_nextMeeting': return 'Nästa möte';
    }
    return '';
  }
}
